import { X } from "lucide-react";
import getInitials from "./utils";

export default function OwnerHeaderCell({ owner, index, setOwners }) {
  const { name } = owner.user;

  function handleRemoveOwner() {
    setOwners((prev) => prev.filter((_, i) => i !== index));
  }

  return (
    <th
      scope="col"
      className="relative px-4 py-4 text-center align-middle font-sans text-xs font-semibold text-slate-700 min-w-[110px]"
    >
      <button
        type="button"
        onClick={handleRemoveOwner}
        className="absolute right-2 top-2 rounded-md p-1 text-slate-400 transition-all duration-200 hover:bg-rose-50 hover:text-rose-600 focus:outline-none"
        title={`Remove ${name}`}
      >
        <X size={12} />
      </button>

      <div className="flex flex-col items-center gap-2">
        <div className="relative">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-xs font-semibold text-slate-600 ring-2 ring-white shadow-sm">
            {getInitials(name)}
          </div>
          <span className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full border-2 border-white bg-emerald-500" />
        </div>
        <span className="truncate max-w-[100px] text-slate-600 font-medium tracking-tight">{name}</span>
      </div>
    </th>
  );
}